export function camelToSnakeCase(name: string): string {
    return name.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
}

/**
 * Deeply translates all keys of an object from camelCase to snake_case. Also accepts non-object and non-array values.
 * @param value - The object whose keys need to be converted, or any other value.
 * @returns A new object with snake_case keys, or the same value is was provided.
 */
export function camelToSnakeKeys<T>(value: T): T {
    if (value === null || value instanceof Date) {
        return value;
    } else if (Array.isArray(value)) {
        return value.map(camelToSnakeKeys) as T;
    } else if (typeof value === "object") {
        return Object.fromEntries(
            Object.entries(value).map(([k, v]) => [camelToSnakeCase(k), camelToSnakeKeys(v)]),
        ) as T;
    } else {
        return value;
    }
}
